const $ = require("jquery");

$(document).ready(() => {
  $('a[href$=".pdf"]').attr("target", "_blank");

  $('a[href^="https://"]')
    .not(`a[href*="${window.location.host}"]`)
    .attr("target", "_blank");
});
